var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapClasses },
    [
      _vm.prepend
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.slotReady,
                  expression: "slotReady"
                }
              ],
              class: [_vm.prefixCls + "-group-prepend"]
            },
            [_vm._t("prepend")],
            2
          )
        : _vm._e(),
      _vm.clearable && _vm.currentValue
        ? _c(
            "i",
            {
              staticClass: "am-icon",
              class: [
                "am-icon-ios-close-circle",
                _vm.prefixCls + "-icon",
                _vm.prefixCls + "-icon-clear",
                _vm.prefixCls + "-icon-normal"
              ],
              on: { click: _vm.handleClear }
            },
            [_vm._v("\n      ×\n    ")]
          )
        : _vm.icon
        ? _c("i", {
            staticClass: "am-icon",
            class: [
              "am-icon-" + _vm.icon,
              _vm.prefixCls + "-icon",
              _vm.prefixCls + "-icon-normal"
            ],
            on: { click: _vm.handleIconClick }
          })
        : _vm.search && _vm.enterButton === false
        ? _c("i", {
            staticClass: "am-icon am-icon-ios-search",
            class: [
              _vm.prefixCls + "-icon",
              _vm.prefixCls + "-icon-normal",
              _vm.prefixCls + "-search-icon"
            ],
            on: { click: _vm.handleSearch }
          })
        : _vm.showSuffix
        ? _c(
            "span",
            { staticClass: "am-input-suffix" },
            [
              _vm._t("suffix", function() {
                return [
                  _vm.suffix
                    ? _c("i", {
                        staticClass: "am-icon",
                        class: ["am-icon-" + _vm.suffix]
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.icon
          ? _c("i", {
              staticClass: "am-icon am-icon-ios-loading am-load-loop",
              class: [_vm.prefixCls + "-icon", _vm.prefixCls + "-icon-validate"]
            })
          : _vm._e()
      ]),
      _c("input", {
        ref: "input",
        class: _vm.inputClasses,
        attrs: {
          id: _vm.elementId,
          type: _vm.type,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          readonly: _vm.readonly,
          name: _vm.name,
          number: _vm.number,
          autofocus: _vm.autofocus
        },
        domProps: { value: _vm.currentValue },
        on: {
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleEnter.apply(null, arguments)
            },
            _vm.handleKeyup
          ],
          keypress: _vm.handleKeypress,
          keydown: _vm.handleKeydown,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          input: _vm.handleInput,
          change: _vm.handleChange
        }
      }),
      _vm.append
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.slotReady,
                  expression: "slotReady"
                }
              ],
              class: [_vm.prefixCls + "-group-append"]
            },
            [_vm._t("append")],
            2
          )
        : _vm.search && _vm.enterButton
        ? _c(
            "div",
            {
              class: [
                _vm.prefixCls + "-group-append",
                _vm.prefixCls + "-search"
              ],
              on: { click: _vm.handleSearch }
            },
            [
              _vm.enterButton === true
                ? _c("i", { staticClass: "am-icon am-icon-ios-search" })
                : [_vm._v(_vm._s(_vm.enterButton))]
            ],
            2
          )
        : _vm.showPrefix
        ? _c(
            "span",
            { staticClass: "am-input-prefix" },
            [
              _vm._t("prefix", function() {
                return [
                  _vm.prefix
                    ? _c("i", {
                        staticClass: "am-icon",
                        class: ["am-icon-" + _vm.prefix]
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9dce6cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9dce6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Input/Input.vue
// module id = e478
// module chunks = 0 3